var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pad30" },
    [
      _c("h2", { staticClass: "f18 fb normal gray_2" }, [_vm._v("渠道归属")]),
      _c("div", { staticClass: "box20" }),
      _c(
        "div",
        { staticClass: "flex flex-wrap flex1 items-center mar20-b" },
        [
          _c(
            "div",
            [
              _c("span", [_vm._v("客户名称：")]),
              _c("el-input", {
                staticClass: "w210 mar20_r",
                attrs: { placeholder: "请输入客户名称" },
                model: {
                  value: _vm.searchForm.name,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.searchForm,
                      "name",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "searchForm.name"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            [
              _c("span", [_vm._v("手机号：")]),
              _c("el-input", {
                staticClass: "w210 mar20_r",
                attrs: { placeholder: "请输入手机号" },
                model: {
                  value: _vm.searchForm.phone,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.searchForm,
                      "phone",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "searchForm.phone"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            [
              _c("span", [_vm._v("分组名称：")]),
              _c(
                "el-select",
                {
                  staticClass: "w210 mar20_r",
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.searchForm.groupId,
                    callback: function($$v) {
                      _vm.$set(_vm.searchForm, "groupId", $$v)
                    },
                    expression: "searchForm.groupId"
                  }
                },
                _vm._l(_vm.groupList, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.getList } },
            [_vm._v("查询")]
          )
        ],
        1
      ),
      _c(
        "el-table",
        { attrs: { border: "", data: _vm.list, "row-class-name": "pointer" } },
        [
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "name",
              label: "客户名称"
            }
          }),
          _c("el-table-column", {
            attrs: { prop: "phone", label: "联系电话" }
          }),
          _c("el-table-column", {
            attrs: { prop: "groupName", label: "分组" }
          }),
          _c("el-table-column", {
            attrs: { prop: "channelServiceOrgName", label: "渠道归属" }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "channelServiceRebate",
              label: "返利比例(店铺积分)"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(scope.row.channelServiceRebate) + "%")
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "240" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.isExistChannelRevert === 1
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "danger" },
                            on: {
                              click: function($event) {
                                return _vm.setOrg(scope.row, "cancel")
                              }
                            }
                          },
                          [_vm._v("取消渠道")]
                        )
                      : _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.setOrg(scope.row)
                              }
                            }
                          },
                          [_vm._v("渠道设置")]
                        ),
                    _c(
                      "el-button",
                      {
                        staticClass: "mar15-l",
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.setEbate(scope.row)
                          }
                        }
                      },
                      [_vm._v("返利设置")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flex items-center mar20-t" },
        [
          _c("div", { staticClass: "gray9 flex-auto" }, [
            _vm._v(
              "共 " +
                _vm._s(_vm.pageTotal) +
                " 条记录 第 " +
                _vm._s(_vm.pageNum) +
                " / " +
                _vm._s(_vm.totalPage) +
                " 页"
            )
          ]),
          _c("el-pagination", {
            attrs: {
              layout: "prev, pager, next, sizes, jumper",
              background: "",
              "hide-on-single-page": "",
              "page-size": _vm.pageSize,
              "page-count": _vm.totalPage,
              "current-page": _vm.pageNum,
              "page-sizes": [10, 50, 100]
            },
            on: {
              "update:pageSize": function($event) {
                _vm.pageSize = $event
              },
              "update:page-size": function($event) {
                _vm.pageSize = $event
              },
              "update:currentPage": function($event) {
                _vm.pageNum = $event
              },
              "update:current-page": function($event) {
                _vm.pageNum = $event
              },
              "size-change": _vm.sizeChange,
              "current-change": _vm.currentChange
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "设置渠道返利",
            visible: _vm.ebateVisible,
            width: "500",
            "close-on-click-modal": false,
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              _vm.ebateVisible = $event
            }
          }
        },
        [
          _c("div", [
            _c("div", [
              _vm._v("渠道：" + _vm._s(_vm.customer.channelServiceOrgName))
            ]),
            _c(
              "div",
              { staticClass: "mar20-tb" },
              [
                _c("span", [_vm._v("返利比例：")]),
                _c("el-input", {
                  staticClass: "w150 mar5-r",
                  attrs: {
                    oninput:
                      "value=value.replace(/[^\\d^\\.]+/g,'').replace('.','$#$').replace(/\\./g,'').replace('$#$','.').replace(/^(\\-)*(\\d+)\\.(\\d\\d).*$/,'$1$2.$3')",
                    placeholder: "请输入返利比例"
                  },
                  model: {
                    value: _vm.channelServiceRebate,
                    callback: function($$v) {
                      _vm.channelServiceRebate =
                        typeof $$v === "string" ? $$v.trim() : $$v
                    },
                    expression: "channelServiceRebate"
                  }
                }),
                _c("span", [_vm._v("%")])
              ],
              1
            ),
            _c("div", [
              _c("div", { staticClass: "mar5-b" }, [_vm._v("注：")]),
              _c("div", { staticClass: "mar5-b" }, [
                _vm._v("1、返利仅支持按本客户实际支付金额的比例发放店铺积分")
              ]),
              _c("div", { staticClass: "mar5-b" }, [
                _vm._v("2、如比例默认为0%，如为0，则视为关系不存在")
              ]),
              _c("div", [
                _vm._v(
                  "3、单独设置了积分发放规则（为支付完成后发放）后，如客户触发积分规则，客户和渠道均会获取积分"
                )
              ])
            ])
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.ebateVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.ebateSubmit } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "orgDialog",
          attrs: {
            title: "设置归属渠道",
            visible: _vm.orgVisible,
            width: "700",
            "close-on-click-modal": false,
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              _vm.orgVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "flex flex-wrap flex1 items-center mar20-b" },
                [
                  _c(
                    "el-input",
                    {
                      staticClass: "input-with-select w280 mar20_r",
                      attrs: {
                        placeholder:
                          _vm.querySel === 1
                            ? "请输入渠道名称"
                            : "请输入联系方式"
                      },
                      model: {
                        value: _vm.orgNameOrPhone,
                        callback: function($$v) {
                          _vm.orgNameOrPhone = $$v
                        },
                        expression: "orgNameOrPhone"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { slot: "prepend", placeholder: "请选择" },
                          slot: "prepend",
                          model: {
                            value: _vm.querySel,
                            callback: function($$v) {
                              _vm.querySel = $$v
                            },
                            expression: "querySel"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "企业", value: 1 }
                          }),
                          _c("el-option", {
                            attrs: { label: "个人", value: 2 }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.getOrgList }
                    },
                    [_vm._v("查询")]
                  )
                ],
                1
              ),
              _vm.querySel === 1
                ? [
                    _c(
                      "el-table",
                      {
                        attrs: {
                          border: "",
                          data: _vm.orgList,
                          "row-class-name": "pointer"
                        },
                        on: { "selection-change": _vm.selectionChange }
                      },
                      [
                        _c("el-table-column", {
                          attrs: { type: "selection", width: "55" }
                        }),
                        _c("el-table-column", {
                          attrs: {
                            "show-overflow-tooltip": "",
                            prop: "id",
                            label: "ID"
                          }
                        }),
                        _c("el-table-column", {
                          attrs: {
                            "show-overflow-tooltip": "",
                            prop: "name",
                            label: "名称"
                          }
                        }),
                        _c("el-table-column", {
                          attrs: {
                            "show-overflow-tooltip": "",
                            prop: "state",
                            label: "状态",
                            width: "100"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    scope.row.status === 8
                                      ? _c("span", [_vm._v("已认证")])
                                      : _c("span", [_vm._v("未认证")])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            540096533
                          )
                        }),
                        _c("el-table-column", {
                          attrs: {
                            "show-overflow-tooltip": "",
                            prop: "adminName",
                            label: "管理员"
                          }
                        })
                      ],
                      1
                    )
                  ]
                : [
                    _c(
                      "el-table",
                      {
                        attrs: {
                          border: "",
                          data: _vm.orgList,
                          "row-class-name": "pointer"
                        },
                        on: { "selection-change": _vm.selectionChange }
                      },
                      [
                        _c("el-table-column", {
                          attrs: { type: "selection", width: "55" }
                        }),
                        _c("el-table-column", {
                          attrs: {
                            "show-overflow-tooltip": "",
                            prop: "id",
                            label: "ID"
                          }
                        }),
                        _c("el-table-column", {
                          attrs: {
                            "show-overflow-tooltip": "",
                            prop: "name",
                            label: "名称"
                          }
                        })
                      ],
                      1
                    )
                  ]
            ],
            2
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.orgVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.orgSubmit } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }